import AppHeader from "@saleor/components/AppHeader";
import Container from "@saleor/components/Container";
import LanguageSwitch from "@saleor/components/LanguageSwitch";
import PageHeader from "@saleor/components/PageHeader";
import { SaleTranslationFragment } from "@saleor/fragments/types/SaleTranslationFragment";
import { commonMessages, sectionNames } from "@saleor/intl";
import { TranslationsEntitiesPageProps } from "@saleor/translations/types";
import React from "react";
import { useIntl } from "react-intl";

import { maybe } from "../../../misc";
import { LanguageCodeEnum } from "../../../types/globalTypes";
import TranslationFields from "../TranslationFields";

export interface TranslationsSalesPageProps
  extends TranslationsEntitiesPageProps {
  sale: SaleTranslationFragment;
}

export const fieldNames = {
  name: "name",
  superName: "superName",
  superPriceImage: "superPriceImage",
  superPriceText: "superPriceText",
  superPriceImageMb: "superPriceImageMb"
};

const TranslationsSalesPage: React.FC<TranslationsSalesPageProps> = ({
  activeField,
  disabled,
  languageCode,
  languages,
  sale,
  saveButtonState,
  onBack,
  onDiscard,
  onEdit,
  onLanguageChange,
  onSubmit
}) => {
  const intl = useIntl();

  return (
    <Container>
      <AppHeader onBack={onBack}>
        {intl.formatMessage(sectionNames.translations)}
      </AppHeader>
      <PageHeader
        title={intl.formatMessage(
          {
            defaultMessage: 'Translation Sale "{saleName}" - {languageCode}',
            description: "header"
          },
          {
            languageCode,
            saleName: maybe(() => sale.name, "...")
          }
        )}
      >
        <LanguageSwitch
          currentLanguage={LanguageCodeEnum[languageCode]}
          languages={languages}
          onLanguageChange={onLanguageChange}
        />
      </PageHeader>
      <TranslationFields
        activeField={activeField}
        disabled={disabled}
        initialState={true}
        title={intl.formatMessage(commonMessages.generalInformations)}
        fields={[
          {
            displayName: intl.formatMessage({
              defaultMessage: "Sale Name"
            }),
            name: fieldNames.name,
            translation: maybe(() =>
              sale.translation ? sale.translation.name : null
            ),
            type: "short" as "short",
            value: maybe(() => sale.name)
          },
          {
            displayName: intl.formatMessage({
              defaultMessage: "Sale superPriceImage"
            }),
            name: fieldNames.superPriceImage,
            translation: maybe(() =>
              sale.translation ? sale.translation.superPriceImage : null
            ),
            type: "short" as "short",
            value: maybe(() => sale.superPriceImage)
          },
          {
            displayName: intl.formatMessage({
              defaultMessage: "Sale superPriceImageMb"
            }),
            name: fieldNames.superPriceImageMb,
            translation: maybe(() =>
              sale.translation ? sale.translation.superPriceImageMb : null
            ),
            type: "short" as "short",
            value: maybe(() => sale.superPriceImageMb)
          },

          {
            displayName: intl.formatMessage({
              defaultMessage: "Sale superName"
            }),
            name: fieldNames.superName,
            translation: maybe(() =>
              sale.translation ? sale.translation.superName : null
            ),
            type: "short" as "short",
            value: maybe(() => sale.superName)
          },

          {
            displayName: intl.formatMessage({
              defaultMessage: "Sale superPriceText"
            }),
            name: fieldNames.superPriceText,
            translation: maybe(() =>
              sale.translation ? sale.translation.superPriceText : null
            ),
            type: "short" as "short",
            value: maybe(() => sale.superPriceText)
          }
        ]}
        saveButtonState={saveButtonState}
        onEdit={onEdit}
        onDiscard={onDiscard}
        onSubmit={onSubmit}
      />
    </Container>
  );
};
TranslationsSalesPage.displayName = "TranslationsSalesPage";
export default TranslationsSalesPage;
